
















import { Component, Vue } from 'vue-property-decorator';
import MeteorIcon from '../../../components/icons/MeteorIcon.vue';
import XIcon from '../../../components/icons/XIcon.vue';

@Component({
  components: {
    MeteorIcon,
    XIcon,
  },
})
export default class DailyChallengeXPHeader extends Vue {}
